import { Text } from '../../cdl/Text/Text';
import { truncateMiddle } from '../../common/helpers/truncateMiddle.helper';
import { useRole } from '../../common/hooks/useRole';

import { HoverableCopyToClipboardButton } from './HoverableCopyToClipboardButton';

interface ApiKeyDisplayProps {
    apiKey: string;
}

export const ApiKeyDisplay = ({ apiKey }: ApiKeyDisplayProps) => {
    const role = useRole();

    const truncatedApiKey = truncateMiddle(apiKey);

    if (!role.isSuperAdmin()) {
        return <Text variant="small">{truncatedApiKey}</Text>;
    }

    return (
        <HoverableCopyToClipboardButton copyValue={apiKey}>
            <Text variant="small">{truncatedApiKey}</Text>
        </HoverableCopyToClipboardButton>
    );
};
